import React, { useState } from 'react';
import { Accordion, Box, Button, Card, Group, Stack, Text } from '@mantine/core';

interface TransportationOption {
    title: string;
    description: string[];
    imgComponent: (arg: boolean) => React.ReactNode;
    url: string;
}

interface GridOptionItemProps {
    option: TransportationOption;
    selectedMode?: 'hotel' | 'cruise';
    onSelect?: (mode: 'hotel' | 'cruise') => void;
}

function GridOptionItem({ option, selectedMode, onSelect }: GridOptionItemProps) {
    const initialSentence = option.description[0];
    const remaining = option.description.slice(1);
    const [expanded, setExpanded] = useState(true);
    const isCruise = option.title.toLowerCase().includes("cruise");
    const optionMode: 'hotel' | 'cruise' = isCruise ? 'cruise' : 'hotel';
    const buttonLabel = isCruise ? "Browse cruise tours" : "Browse hotel tours";

    return (
        <Card
            shadow="md"
            radius="lg"
            withBorder
            className={selectedMode === optionMode ? "gridOptionCard selected" : "gridOptionCard"}
            bg="white"
        >
            <Card.Section>
                <Box p="md" className="gridOptionMedia">
                    {option.imgComponent(false)}
                </Box>
            </Card.Section>
            <Stack p="md" gap="sm">
                <Text fw={700} size="lg" ta="center" c="dark">{option.title}</Text>
                <Text c="dark" size="sm" style={{ opacity: 0.95 }}>{initialSentence}</Text>
                {remaining.length > 0 && (
                    <Accordion
                        variant="contained"
                        radius="md"
                        value={expanded ? "details" : null}
                        onChange={(value) => setExpanded(value === "details")}
                    >
                        <Accordion.Item value="details">
                            <Accordion.Control>{expanded ? "Show less" : "Show more"}</Accordion.Control>
                            <Accordion.Panel>
                                {remaining.map((desc, index) => (
                                    <Text key={index} size="sm" c="dark" style={{ opacity: 0.95 }} mb="xs">
                                        {desc}
                                    </Text>
                                ))}
                            </Accordion.Panel>
                        </Accordion.Item>
                    </Accordion>
                )}
                <Group justify="center" gap="sm" wrap="wrap">
                    <Button component="a" href={option.url} color="brand" radius="xl" variant="light">
                        {buttonLabel}
                    </Button>
                    <Button
                        color="accent"
                        radius="xl"
                        variant={selectedMode === optionMode ? "filled" : "outline"}
                        onClick={() => onSelect?.(optionMode)}
                    >
                        {selectedMode === optionMode ? "Selected" : "Select embarkation"}
                    </Button>
                </Group>
            </Stack>
        </Card>
    );
}

export default GridOptionItem;
